module.exports = __webpack_public_path__ + "static/media/glanum_nymphaeum_tn.d0322535.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/glanum_nymphaeum_tn.jpg
// module id = 722
// module chunks = 0